import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import TableChartIcon from '@mui/icons-material/TableChart';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import ArchiveIcon from '@mui/icons-material/Archive';
import CodeIcon from '@mui/icons-material/Code';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import {
  getEnhancementFileCategory,
  ENHANCEMENT_FILE_COLOR_BY_CATEGORY,
} from './enhancementFileTypeConfig';

export const ENHANCEMENT_STATUS_COLORS = {
  Pending: '#ff9800',
  Approved: '#4caf50',
  Rejected: '#f44336',
  'In Progress': '#2196f3',
  Completed: '#9c27b0',
};

export const formatEnhancementDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const FILE_ICON_BY_CATEGORY = {
  pdf: PictureAsPdfIcon,
  image: ImageIcon,
  document: DescriptionIcon,
  spreadsheet: TableChartIcon,
  presentation: SlideshowIcon,
  video: VideoFileIcon,
  audio: AudioFileIcon,
  archive: ArchiveIcon,
  code: CodeIcon,
  default: InsertDriveFileIcon,
};

export const getEnhancementFileIcon = (fileName) => {
  const category = getEnhancementFileCategory(fileName);
  const Icon = FILE_ICON_BY_CATEGORY[category] || FILE_ICON_BY_CATEGORY.default;
  return <Icon />;
};

export const getEnhancementFileColor = (fileName) => {
  const category = getEnhancementFileCategory(fileName);
  return ENHANCEMENT_FILE_COLOR_BY_CATEGORY[category] || ENHANCEMENT_FILE_COLOR_BY_CATEGORY.default;
};

export const downloadEnhancementAttachmentFromUrl = (url, name) => {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.download = name || 'attachment';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
